import React from 'react';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
//custom-hook
import useAssignedLibrary from 'utils/customHooks/useAssignedLibrary';
//components
import Button from 'components/userzone/buttons/ButtonCustom';

const SectionAffiliate = () => {
  const { t } = useTranslation(['home']);
  const { assignedLibrary} = useAssignedLibrary();

  return (
    <div className="affiliate-container d-flex flex-column align-items-center  pb-4">
      <h3 className="text-center mb-4"><strong>{t('joinBookstore') }</strong></h3>
      <Link to={`/${assignedLibrary}/afiliate`}>
        <Button 
          variant="primary"
          extraClass="affiliate-button"
        >
          {t('affiliate')}
        </Button>
      </Link>
    </div>
  );
};

export default SectionAffiliate;
